import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    initializeFeatureFlag,
    selectIsROneFlagInitialized,
} from 'store/featureFlag/featureFlagSlice';
import { JOB_GID_QUERY_PARAM_NAME } from 'utils/config/constants';

// Hook for initializing at app root
export const useROneFlagInitializer = () => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const isInitialized = useAppSelector(selectIsROneFlagInitialized);

    useEffect(() => {
        if (!isInitialized) {
            const urlParam = searchParams.get(JOB_GID_QUERY_PARAM_NAME) || undefined;
            dispatch(initializeFeatureFlag({ urlParam }));
        }
    }, [dispatch, searchParams, isInitialized]);
};
